import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import firebase from "firebase/compat/app";
import "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyCAGk8MQwgdPPygQ0A4tm8h4VspLSKRvoc",
  authDomain: "vis-circuit.firebaseapp.com",
  projectId: "vis-circuit",
  storageBucket: "vis-circuit.firebasestorage.app",
  messagingSenderId: "960777510090",
  appId: "1:960777510090:web:dbfa58bb6c9ac7feebe833",
  measurementId: "G-2D7W7Q7QL0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

export { db, app };
